import { SyncActionFactory } from 'app/shared/utils/redux/sync.actions'

export class GeneralSettingsActions {
  public static setWarningRowColoration = new SyncActionFactory<boolean>(
    '[GENERAL_SETTINGS] SET_WARNING_ROW_COLORATION',
  )
}
